module.exports = __webpack_public_path__ + "img/br33.7b951e7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/br33.jpg
// module id = Xhgp
// module chunks = 0